import { useAuth0 } from "@auth0/auth0-react"
import React, { useCallback } from "react"

import { Icon } from "semantic-ui-react"
import { isSuperAdminOrAdmin } from "../../../../../Utils/util"
import BifrostList from "../../../../BifrostElementComponent/BifrostList/BifrostList"
import AddUserToGroupModal from "../GroupDetailModal/AddUserToGroupModal"
import RemoveFromGroupModal from "../GroupDetailModal/RemoveFromGroupModal"

const GroupStructUsers = ({ group, refreshData }) => {
	const listHandler = useCallback(() => {
		const { user } = useAuth0()

		const groupUsers = group.users
		groupUsers.forEach((element) => {
			element.name = element.nickname
			element.type = element.role
			element.listType = "users"
			{
				isSuperAdminOrAdmin(user) ? (element.listHandler = <RemoveFromGroupModal item={element} group={group} refreshData={refreshData} />) : null
			}

			switch (element.role) {
				case "Admin":
					element.icon = <Icon color="blue" name="user" />
					break
				case "SuperAdmin":
					element.icon = <Icon color="green" name="user" />
					break
				case "ResellerAdmin":
					element.icon = <Icon color="orange" name="user" />
					break
				default:
					element.icon = <Icon color="grey" name="user" />
			}
		})

		return groupUsers
	}, [group])

	const addUserToGroupModalHandler = () => {
		if (isSuperAdminOrAdmin(useAuth0().user)) {
			return <AddUserToGroupModal group={group} refreshData={refreshData} />
		}
	}

	return (
		<BifrostList
			list={{
				struct: "group",
				name: "Users",
				path: "/users/",
				icon: <Icon name="users" />,
				description: group.users.length,
				operationButton: addUserToGroupModalHandler(),
				content: listHandler()
			}}
		/>
	)
}

GroupStructUsers.propTypes = {}

export default GroupStructUsers
